/* eslint-disable indent */
import React from 'react';
import styled, { css } from 'styled-components';
import { getMediaQuery } from '@carvana/showroom-theme';
import PlayButtonSmallIcon from '../../images/icons/play-button-small.svg';

export const LargeVideoPlayer = css`
  width: 90vw;
  height: 210px;
  margin-top: 3rem;

  ${(props) => getMediaQuery(props.theme.breakpoint.md)} {
    margin-top: 0;
    width: 436px;
    height: 280px;
    /* height: auto; */
    /* height: 370px; */
  }

  ${(props) => getMediaQuery(props.theme.breakpoint.xl)} {
    width: 656px;
    height: 370px;
  }
`;

export const VideoWrapper = styled.video`
  width: 354px;
  height: 200px;

  &::-webkit-media-controls-overflow-button {
    display: none !important;
  }

  opacity: 0;
  visibility: hidden;
  transition: opacity 500ms ease-in, transform 500ms ease-out;
  will-change: opacity, visibility;

  ${(props) =>
    props.isVideoLoaded &&
    css`
      opacity: 1;
      visibility: visible;
    `}

  ${(props) => props.size === 'large' && LargeVideoPlayer};
`;

// √ We need a cover poster that is shown if a poster was passed in.
// √ if the cover poster is shown, we keep showing until the users clicks the 'play' button
// √ once the play button is clicked, we wait for the 'onLoaded' event
// √ once loaded, we fade-in video, and fade-out cover poster
// √ should only happen on first load
// √ for ssr, we should only show the cover poster - prevetns video from being loaded

export const ImagePoster = styled.div`
  width: 100%;
  height: 200px;
  background-image: url('${(props) => props.src}');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-color: ${(props) => props.theme.color.neutral.v000};

  opacity: 1;
  visibility: visible;
  transition: opacity 500ms linear;
  /* transition: opacity 500ms ease-out, transform 500ms ease-in; */
  will-change: opacity, visibility;
  /* display: block; */

  ${(props) =>
    props.isVideoLoaded &&
    css`
      opacity: 0;
      visibility: hidden;
      display: none;
      /* transition: visibility 0s 2s, opacity 2s linear; */
    `}

  ${(props) => props.size === 'large' && LargeVideoPlayer};
`;

export const LoadingSvg = styled.svg`
  animation: 2s linear infinite svg-animation;
  position: absolute;
  left: 12px;
  bottom: 12px;
  max-width: 40px;

  @keyframes svg-animation {
    0% {
      transform: rotateZ(0deg);
    }
    100% {
      transform: rotateZ(360deg);
    }
  }

  > circle {
    animation: 1.4s ease-in-out infinite both circle-animation;
    display: block;
    fill: transparent;
    stroke: ${(props) => props.theme.color.primary.v200};
    stroke-linecap: round;
    stroke-dasharray: 283;
    stroke-dashoffset: 280;
    stroke-width: 10px;
    transform-origin: 50% 50%;
  }

  @keyframes circle-animation {
    0%,
    25% {
      stroke-dashoffset: 280;
      transform: rotate(0);
    }

    50%,
    75% {
      stroke-dashoffset: 75;
      transform: rotate(45deg);
    }

    100% {
      stroke-dashoffset: 280;
      transform: rotate(360deg);
    }
  }

  ${(props) => getMediaQuery(props.theme.breakpoint.lg)} {
    ${(props) =>
      props.size === 'large' &&
      css`
        left: 9px;
        bottom: 11px;
        max-width: 94px;
      `}
  }
`;

export const CircleBackground = styled.div`
  border-radius: 50%;
  width: 2rem;
  height: 2rem;
  background-color: ${(props) => props.theme.color.neutral.v100};
  position: absolute;
  left: 1rem;
  bottom: 1rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  ${(props) => getMediaQuery(props.theme.breakpoint.lg)} {
    ${(props) =>
      props.size === 'large' &&
      css`
        width: 80px;
        height: 80px;
      `}
  }
`;

export const PlayButtonSmall = styled(PlayButtonSmallIcon)`
  width: 16px;
  height: 16px;
  margin-left: 2px;

  ${(props) => getMediaQuery(props.theme.breakpoint.lg)} {
    ${(props) =>
      props.size === 'large' &&
      css`
        width: 24px;
        height: 24px;
      `}
  }
`;

export const CircleLoadingIcon = ({ size }) => (
  <LoadingSvg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" size={size}>
    <circle cx="50" cy="50" r="45" />
  </LoadingSvg>
);

export const VideoTitle = styled.div`
  position: absolute;
  color: ${(props) => props.theme.color.neutral.v100};
  font-weight: 700;
  text-transform: uppercase;
  line-height: 24px;
  bottom: 21px;
  left: 4rem;

  ${(props) => getMediaQuery(props.theme.breakpoint.lg)} {
    bottom: 45px;
    left: 7rem;
  }
`;
